"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Input = _interopRequireDefault(require("angieslist-react-components/lib/Input"));

var _excluded = ["id", "useAbbreviationValue", "chooseText"];
var regions = [{
  name: 'Alabama',
  regionId: 1,
  abbreviation: 'AL',
  countryId: 1
}, {
  name: 'Alaska',
  regionId: 2,
  abbreviation: 'AK',
  countryId: 1
}, {
  name: 'Arizona',
  regionId: 3,
  abbreviation: 'AZ',
  countryId: 1
}, {
  name: 'Arkansas',
  regionId: 4,
  abbreviation: 'AR',
  countryId: 1
}, {
  name: 'California',
  regionId: 5,
  abbreviation: 'CA',
  countryId: 1
}, {
  name: 'Colorado',
  regionId: 6,
  abbreviation: 'CO',
  countryId: 1
}, {
  name: 'Connecticut',
  regionId: 7,
  abbreviation: 'CT',
  countryId: 1
}, {
  name: 'Delaware',
  regionId: 8,
  abbreviation: 'DE',
  countryId: 1
}, {
  name: 'District Of Columbia',
  regionId: 59,
  abbreviation: 'DC',
  countryId: 1
}, {
  name: 'Florida',
  regionId: 9,
  abbreviation: 'FL',
  countryId: 1
}, {
  name: 'Georgia',
  regionId: 10,
  abbreviation: 'GA',
  countryId: 1
}, {
  name: 'Hawaii',
  regionId: 11,
  abbreviation: 'HI',
  countryId: 1
}, {
  name: 'Idaho',
  regionId: 12,
  abbreviation: 'ID',
  countryId: 1
}, {
  name: 'Illinois',
  regionId: 13,
  abbreviation: 'IL',
  countryId: 1
}, {
  name: 'Indiana',
  regionId: 14,
  abbreviation: 'IN',
  countryId: 1
}, {
  name: 'Iowa',
  regionId: 15,
  abbreviation: 'IA',
  countryId: 1
}, {
  name: 'Kansas',
  regionId: 16,
  abbreviation: 'KS',
  countryId: 1
}, {
  name: 'Kentucky',
  regionId: 17,
  abbreviation: 'KY',
  countryId: 1
}, {
  name: 'Louisiana',
  regionId: 18,
  abbreviation: 'LA',
  countryId: 1
}, {
  name: 'Maine',
  regionId: 19,
  abbreviation: 'ME',
  countryId: 1
}, {
  name: 'Maryland',
  regionId: 20,
  abbreviation: 'MD',
  countryId: 1
}, {
  name: 'Massachusetts',
  regionId: 21,
  abbreviation: 'MA',
  countryId: 1
}, {
  name: 'Michigan',
  regionId: 22,
  abbreviation: 'MI',
  countryId: 1
}, {
  name: 'Minnesota',
  regionId: 23,
  abbreviation: 'MN',
  countryId: 1
}, {
  name: 'Mississippi',
  regionId: 24,
  abbreviation: 'MS',
  countryId: 1
}, {
  name: 'Missouri',
  regionId: 25,
  abbreviation: 'MO',
  countryId: 1
}, {
  name: 'Montana',
  regionId: 26,
  abbreviation: 'MT',
  countryId: 1
}, {
  name: 'Nebraska',
  regionId: 27,
  abbreviation: 'NE',
  countryId: 1
}, {
  name: 'Nevada',
  regionId: 28,
  abbreviation: 'NV',
  countryId: 1
}, {
  name: 'New Hampshire',
  regionId: 29,
  abbreviation: 'NH',
  countryId: 1
}, {
  name: 'New Jersey',
  regionId: 30,
  abbreviation: 'NJ',
  countryId: 1
}, {
  name: 'New Mexico',
  regionId: 31,
  abbreviation: 'NM',
  countryId: 1
}, {
  name: 'New York',
  regionId: 32,
  abbreviation: 'NY',
  countryId: 1
}, {
  name: 'North Carolina',
  regionId: 33,
  abbreviation: 'NC',
  countryId: 1
}, {
  name: 'North Dakota',
  regionId: 34,
  abbreviation: 'ND',
  countryId: 1
}, {
  name: 'Ohio',
  regionId: 35,
  abbreviation: 'OH',
  countryId: 1
}, {
  name: 'Oklahoma',
  regionId: 36,
  abbreviation: 'OK',
  countryId: 1
}, {
  name: 'Oregon',
  regionId: 37,
  abbreviation: 'OR',
  countryId: 1
}, {
  name: 'Pennsylvania',
  regionId: 38,
  abbreviation: 'PA',
  countryId: 1
}, {
  name: 'Rhode Island',
  regionId: 39,
  abbreviation: 'RI',
  countryId: 1
}, {
  name: 'South Carolina',
  regionId: 40,
  abbreviation: 'SC',
  countryId: 1
}, {
  name: 'South Dakota',
  regionId: 41,
  abbreviation: 'SD',
  countryId: 1
}, {
  name: 'Tennessee',
  regionId: 42,
  abbreviation: 'TN',
  countryId: 1
}, {
  name: 'Texas',
  regionId: 43,
  abbreviation: 'TX',
  countryId: 1
}, {
  name: 'Utah',
  regionId: 44,
  abbreviation: 'UT',
  countryId: 1
}, {
  name: 'Vermont',
  regionId: 45,
  abbreviation: 'VT',
  countryId: 1
}, {
  name: 'Virginia',
  regionId: 46,
  abbreviation: 'VA',
  countryId: 1
}, {
  name: 'Washington',
  regionId: 47,
  abbreviation: 'WA',
  countryId: 1
}, {
  name: 'West Virginia',
  regionId: 48,
  abbreviation: 'WV',
  countryId: 1
}, {
  name: 'Wisconsin',
  regionId: 49,
  abbreviation: 'WI',
  countryId: 1
}, {
  name: 'Wyoming',
  regionId: 50,
  abbreviation: 'WY',
  countryId: 1
}]; // Component

var StateSelect = function StateSelect(_ref) {
  var id = _ref.id,
      _ref$useAbbreviationV = _ref.useAbbreviationValue,
      useAbbreviationValue = _ref$useAbbreviationV === void 0 ? false : _ref$useAbbreviationV,
      _ref$chooseText = _ref.chooseText,
      chooseText = _ref$chooseText === void 0 ? 'Select One' : _ref$chooseText,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Input.default, (0, _extends2.default)({}, otherProps, {
    id: id,
    type: "select"
  }), /*#__PURE__*/(0, _jsx2.default)("option", {
    value: ""
  }, void 0, chooseText), regions.map(function (region) {
    var regionId = region.regionId;
    var regionAbbr = region.abbreviation;
    var optionValue = useAbbreviationValue ? regionAbbr : regionId;
    return /*#__PURE__*/(0, _jsx2.default)("option", {
      value: optionValue
    }, regionId, regionAbbr);
  }));
}; // PropTypes


var _default = StateSelect;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/stateselect/StateSelect.js
// module id = 603
// module chunks = 25